<template>
  <div class="config">
    <div class="section" v-if="synchro == 1">
      <h4>企业通讯录配置</h4>
      <el-form
        :model="requestData"
        ref="configIndexForm"
        label-width="100px"
        class="listForm"
      >
        <el-form-item
          label="SECRET"
          prop="corp_sercet"
          :rules="[{ required: true, message: '请输入SECRET' }]"
        >
          <el-input
            v-model="requestData.corp_sercet"
            placeholder="请输入"
          ></el-input>
          <div class="tips">
            企业微信，在“管理工具”-“通讯录同步”里面查看（需开启“API接口同步”）
          </div>
        </el-form-item>

        <el-form-item
          v-if="false"
          label="URL:"
          prop="URL"
          :rules="[{ required: true, message: '请输入URL' }]"
        >
          <el-input v-model="requestData.URL" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item
          v-if="false"
          label="token:"
          prop="token"
          :rules="[{ required: true, message: '请输入token' }]"
        >
          <el-input v-model="requestData.token" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item
          v-if="false"
          label="encodingaeskey:"
          prop="encodingaeskey"
          :rules="[{ required: true, message: '请输入encodingaeskey' }]"
        >
          <el-input
            v-model="requestData.encodingaeskey"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <h4>客户联系配置</h4>
        <el-form-item
          label="SECRET"
          prop="customer_sercet"
          :rules="[{ required: true, message: '请输入SECRET' }]"
        >
          <el-input
            v-model="requestData.customer_sercet"
            placeholder="请输入"
          ></el-input>
          <div class="tips">
            企业微信，在“客户联系”栏，点开“API”小按钮，即可看到
          </div>
        </el-form-item>
      </el-form>
      <div class="bt">
        <el-button type="primary" size="small" @click="nextEvent"
          >下一步</el-button
        >
      </div>
    </div>
    <div class="section2" v-else>
      <div class="header">
        <img src="@/assets/images/header.png" alt="" />
        <p>{{ synchro >= 6 ? '已完成' : '正在同步，请稍等……' }}</p>
      </div>
      <div class="message">
        <div class="label">部门</div>
        <div
          class="columnar"
          :style="synchro >= 3 ? 'background:#4876FF' : ''"
        ></div>
        <div class="status">{{ synchro >= 3 ? '已完成' : '加载中' }}</div>
      </div>
      <div class="message">
        <div class="label">员工</div>
        <div
          class="columnar"
          :style="synchro >= 4 ? 'background:#4876FF' : ''"
        ></div>
        <div class="status">{{ synchro >= 4 ? '已完成' : '加载中' }}</div>
      </div>
      <div class="message">
        <div class="label">标签</div>
        <div
          class="columnar"
          :style="synchro >= 5 ? 'background:#4876FF' : ''"
        ></div>
        <div class="status">{{ synchro >= 5 ? '已完成' : '加载中' }}</div>
      </div>
      <div class="message">
        <div class="label">客户</div>
        <div
          class="columnar"
          :style="synchro >= 6 ? 'background:#4876FF' : ''"
        ></div>
        <div class="status">{{ synchro >= 6 ? '已完成' : '加载中' }}</div>
      </div>
      <div class="bt">
        <button v-show="synchro >= 6" @click="into">去体验</button>
      </div>
      <div class="foot">注：信息加载过程中请勿关闭或者刷新页面</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      synchro: this.$store.state.app.synchro,
      requestData: {},
      show: true,
      request: [
        'synchroDepartment',
        'synchroStaff',
        'synchroLabel',
        'synchroCustomer',
      ],
    }
  },
  mounted() {},
  watch: {
    synchro: {
      immediate: true,
      handler(val) {
        if (val < 7 && val > 1) {
          console.log('执行')
          this.getData(this.request[val - 2])
        }
      },
    },
  },
  methods: {
    nextEvent() {
      let _self = this
      _self.$commonFun.debounce(() => {
        _self.$refs['configIndexForm'].validate((valid) => {
          if (valid) {
            _self.$api.synchroSercet({ ...this.requestData }).then((res) => {
              _self.$commonFun.toast('SUCCESS', 'success')
              this.$store.commit('getSynchro', 2)
              this.synchro = 2
            })
          }
        })
      }, 500)
    },
    getData(urls) {
      this.$api[urls]({})
        .then((res) => {
          console.log(res, 'res')
          this.synchro++
        })
        .catch((res) => {
          console.log(res, 'res')
          if (res != 0) {
            setTimeout(() => {
              this.$store.commit('getSynchro', 1)
              this.synchro = 1
              return
            }, 2000)
          }
        })
    },
    async into() {
      const res = await this.$api.updateCorpToken()
      await this.$store.dispatch('temporaryClear')
      await this.$store.dispatch('setToken', res.token)
      await this.$store.dispatch('myStore', res.merchant)
      this.$emit('isDialogVisible')
      this.$emit('configLS')
    },
  },
}
</script>

<style lang="scss">
.config {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .section {
    width: 500px;
    h4 {
      margin-bottom: 15px;
    }
    .bt {
      width: 100%;
      text-align: center;
      .el-button--small {
        width: 30%;
        height: 38px;
      }
    }
  }
  .section2 {
    width: 400px;
    .bt {
      margin-top: 40px;
      text-align: center;
      button {
        cursor: pointer;
        width: 290px;
        height: 50px;
        border-radius: 25px;
        color: white;
        border: none;
        background: #4876ff;
      }
    }

    .header {
      width: 100%;
      text-align: center;
      margin-bottom: 30px;
      img {
        width: 162px;
        height: 162px;
      }
    }
    .message {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 25px;
      .label {
        padding-left: 10px;
      }
      .columnar {
        width: 280px;
        height: 18px;
        background: #a4aab9;
        border-radius: 10px;
      }
      .status {
        color: #a4aab9;
      }
    }
    .foot {
      width: 100%;
      margin-top: 40px;
      text-align: center;
      color: #999999;
    }
  }
}
</style>
